import React from "react"
import styled, { css } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { T } from "../../styles/typography"
import { Grid, Block, Spacer } from "../../atoms/layout-primitives"
import Text from "../../atoms/text"
import ContentBlock from "../../molecules/content-block"
import withAnimation from "../../util/withAnimation"
import { FadeIn, FadeInBottom } from "../../styles/animations.styles"
import mergeVariants from "../../util/merge-variants"
import Breakpoints from "../../../components/shared/breakpoints"

const Span = styled.span`
  display: inline-block;
`

const AnimatedSpan = withAnimation(Span)

const IconSection = styled.div`
  grid-column: 1 / -1;

  display: flex;
  flex-wrap: wrap;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));
  margin-top: 24px;
  grid-row-gap: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
    //grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 5 / 10;
  }
`
const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const IconImage = styled.img`
  display: inline-block;
  height: 18px;
  width: 18px;
  object-fit: contain;
  margin-right: 12px;
`

const dataTypes = [
  "Venue",
  "Building",
  "Footprint",
  "Level",
  "Unit",
  "Fixture",
  "Section",
  "Geofence",
  "Kiosk",
  "Detail",
  "Opening",
  "Amenity",
  "Anchor",
  "Occupant",
  "Address",
  "Relationship",
]

export default function MappingSolutionsSection() {
  const query = useStaticQuery(graphql`
    query {
      exporterDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Imdf/1_Desktop/imdf_exporter_desktop.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      moleculeIcon: file(
        relativePath: { eq: "1_SOLUTIONS/Imdf/1_Desktop/data_molecule.svg" }
      ) {
        publicURL
      }
    }
  `)

  return (
    <>
      <Spacer
        height={{ sm: "32px", md: "48px", lg: "48px" }}
        style={{ borderTop: "1px solid #2E2E2E26" }}
      />
      <Grid>
        <Block.Animated
          animation={FadeInBottom}
          row={{ md: "1", lg: "1" }}
          col={{ sm: "2 / -2", md: "2 / -2", lg: "1 / 7" }}
          align={{ lg: "flex-start" }}
          justify={{ md: "center" }}
          variants={[
            null,
            css`
              & .gatsby-image-wrapper {
                max-height: 575px;
              }
            `,
            css`
              & .gatsby-image-wrapper {
                max-height: unset;
              }
            `,
          ]}
        >
          <Img
            fluid={query.exporterDesktop.childImageSharp.fluid}
            imgStyle={{ objectFit: "contain" }}
            alt="A laptop displaying Mappedin Developer Tools"
          />
        </Block.Animated>
        <Block
          row={{ sm: "3", lg: "1" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "-6 / -1" }}
          align={{ lg: "center" }}
        >
          <ContentBlock.H2
            title={
              <AnimatedSpan animation={FadeIn}>
                Mappedin's IMDF Exporter
              </AnimatedSpan>
            }
            description={
              <AnimatedSpan animation={FadeInBottom}>
                IMDF is a GeoJSON based format that includes various geometry
                and location data associated with a venue. These files include
                Feature Objects which represent a physical or conceptual element
                of an indoor map. Although each IMDF export is unique, they are
                all composed of the below features.
              </AnimatedSpan>
            }
            variants={[null, { textAlign: "center" }, { textAlign: "left" }]}
          />

          <Spacer height={{ sm: "32px", md: "48px", lg: "48px" }} />
          <Text
            variants={mergeVariants({
              sm: css`
                margin-top: 24px;
                color: var(--slate);
                ${T.sm.h4(500)}
                justify-self: center;
              `,
              md: css`
                margin-top: 0px;
                ${T.md.h4(500)}
              `,
              lg: css`
                ${T.lg.h6(500)}
                line-height: 120%;
              `,
            })}
          >
            Data Types:
          </Text>
          <IconSection>
            {dataTypes.map(type => (
              <IconRow key={type}>
                <IconImage
                  src={query.moleculeIcon.publicURL}
                  alt="A Molecule Icon"
                />
                <Text
                  variants={mergeVariants({
                    sm: css`
                      color: var(--burnt-orange);
                      ${T.sm.h6(500)}
                    `,
                    md: css`
                      margin-top: 0px;
                      ${T.sm.h6(500)}
                    `,
                    lg: css`
                      ${T.sm.h6(500)}
                      line-height: 120%;
                    `,
                  })}
                >
                  {type}
                </Text>
              </IconRow>
            ))}
          </IconSection>
        </Block>
        <Spacer height={{ sm: "32px", md: "48px", lg: "0px" }} />
      </Grid>
      <Spacer height={{ sm: "32px", md: "48px", lg: "96px" }} />
    </>
  )
}
